<template>
	<div style="width:1200px; height:800px;" v-on:keyup.esc="close()">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_5">
					<input type="text" class="int_type sm_int" v-model="keyword" placeholder="Keyword" ref="spkeyword" autofocus autocomplete="off" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>

				<span v-if="limitRecentPO" style="margin-left:10px;">
					Recent
					<select class="tbl_select" style="width:40px;" v-model="po_limit_month" @change="search()">
						<option :value="null"></option>
						<option :value="1">1</option>
						<option :value="2">2</option>
						<option :value="3">3</option>
						<option :value="6">6</option>
					</select>
					month(s) PO,
				</span>

				<span v-if="list_count > 0" class="int_type_no_border" style="height: 20px;margin-left:10px;margin-top:4px;">Count : {{ list_count | commaSeparated }} (Max {{ max_count }} displayed), Double Click the Row to Select</span>
			</div>
		</div>
		<div class="view_inner">
			<div class="fixed-table-container" style="height:670px;">
				<div class="table-wrapper">
					<table id="item_list" class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th style="text-align:center;width:5%;">
									<div class="th-text">
										<a href="javascript:;" @click="sort('code')">Code{{ sortMark('code') }}</a>
									</div>
								</th>
								<th style="text-align:center;width:15%;">
									<div class="th-text">
										<a href="javascript:;" @click="sort('name')">Name{{ sortMark('name') }}</a>
									</div>
								</th>
								<th style="text-align:center;width:8%;"><div class="th-text ">City</div></th>
								<th style="text-align:center;width:4%;"><div class="th-text">State</div></th>
								<th style="text-align:center;width:10%;"><div class="th-text">Tel</div></th>
								<th style="text-align:center;width:10%;"><div class="th-text">Contact Person</div></th>
								<th style="text-align:center;width:12%;"><div class="th-text">Description</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="partner in partners" v-bind:key="partner.code" @dblclick="selectRow(partner)">
								<td>{{ partner.code }}</td>
								<td class="truncate">{{ partner.name }}</td>
								<td class="truncate">{{ partner.address_city }}</td>
								<td class="truncate">{{ partner.address_state }}</td>
								<td>{{ partner.telephone }}</td>
								<td>{{ partner.attention_name }}</td>
								<td class="truncate">{{ partner.description }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div>
					{{ selectedUserIds }}
				</div> -->
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import { apiSelectPartnerList, apiSelectPartner } from '@/api/partner/index.js';

export default {
	data: function() {
		return {
			partners: [],

			keyword: null,
			sort_key: 'name',
			sort_direction: 'ASC',

			po_limit_month: null,

			max_count: 500,
			list_count: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	props: {
		initialKeyword: String,
		customerOnly: Boolean,
		vendorOnly: Boolean,
		limitRecentPO: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		// async submit() {
		// 	if (this.selectedUserIds.length > 0) {
		// 		//this.$toast.success('Saved successfully');
		// 		this.$emit('set-users', this.selectedUserIds);
		// 		this.close();
		// 	} else {
		// 		this.$toast.error('No user selected');
		// 	}
		// },
		// selectAll() {
		// 	var vm = this;

		// 	vm.selectedUserIds = [];
		// 	if (vm.allSelected) {
		// 		this.users.forEach(function(user) {
		// 			vm.selectedUserIds.push(user.user_id);
		// 		});
		// 	}
		// },
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectPartners();
			//console.log(sort_key);
		},
		reset() {
			this.sort_key = 'name';
			this.sort_direction = 'ASC';
			this.keyword = null;
			this.partners = [];
		},
		search() {
			this.selectPartners();
		},
		// selectRow(user) {
		// 	if (this.selectedUserIds.includes(user.user_id)) {
		// 		const index = this.selectedUserIds.indexOf(user.user_id);
		// 		if (index > -1) {
		// 			this.selectedUserIds.splice(index, 1);
		// 		}
		// 	} else this.selectedUserIds.push(user.user_id);
		// },
		async selectPartners() {
			var param = {
				keyword: this.keyword,
				paging_yn: 'N',
				//sort_key: 'name',
				active_yn: 'Y',

				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				max_count: this.max_count,
				// customer_only: this.customerOnly, //'Y',
				// vendor_only: this.vendorOnly,
			};
			if (this.customerOnly) param.customer_only = true;
			if (this.vendorOnly) param.vendor_only = true;
			if (this.po_limit_month) param.po_limit_month = this.po_limit_month;

			const { data } = await apiSelectPartnerList(param);

			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			this.partners = data.partnerList;
			this.list_count = data.list_count;
			if (this.partners.length == 0) {
				this.$toast.warning('No partners found');
			}
			// this.users.forEach(function(user) {
			// 	user.selected = false;
			// });
		},

		async selectRow(partner) {
			var param = {
				code: partner.code,
			};
			if (this.user.company_id == 'newjigu') param.include_specialty = true;

			const { data } = await apiSelectPartner(param);

			//console.log(partner);
			//this.$emit('set-partner', partner);
			this.$emit('set-partner', data.partner);
			this.close();
		},

		async index() {},
		close() {
			this.$emit('close');
		},
	},
	created() {
		this.index();

		if (this.user.company_id == 'minkhair') this.sort_key = 'code';
		//this.selectPartners();
		//this.item = _.cloneDeep(this.selectedItem);
		//console.log(this.limitRecentPO);

		if (this.limitRecentPO) this.po_limit_month = 3;

		if (this.initialKeyword || this.limitRecentPO) {
			this.keyword = this.initialKeyword;
			this.selectPartners();
		}
	},
	mounted() {
		setTimeout(() => {
			this.$refs.spkeyword.focus();
		}, 10);
	},
};
</script>

<style></style>
